import React from "react";
import styles from "./AutoDelete.module.scss";
import ToggleSwitch from "components/toggle-switch";
import { AmplitudePageName, track } from "utils/amplitude";
import getClasses from "utils/getClasses";
const AMPLITUDE_PAGE_NAME: AmplitudePageName = "pro-settings-ai";

const AutoDeleteRecordingsOnNoteSigning = ({
  setChanged,
  autoDeleteRecordingsOnNoteSignings,
  setAutoDeleteRecordingsOnNoteSignings,
}) => {
  return (
    <div className={styles["ai-setting__auto-delete"]}>
      <div className={styles["ai-setting__section-title"]}>
        Automatically Delete Recordings on signing the note
      </div>
      <div className={getClasses("mb-0", styles["ai-setting__toggle"])}>
        <ToggleSwitch
          checked={autoDeleteRecordingsOnNoteSignings}
          onChange={(e) => {
            setChanged(true);
            setAutoDeleteRecordingsOnNoteSignings(e.target.checked);
          }}
          onClick={() =>
            track(AMPLITUDE_PAGE_NAME, "auto-delete-transcript", "click")
          }
        />
        <span aria-hidden="true" className={styles.textBox}>
          Enable automatic deletion for recordings and transcripts on note
          signing
        </span>
      </div>
    </div>
  );
};

export default AutoDeleteRecordingsOnNoteSigning;
